document.addEventListener('DOMContentLoaded', () => {
    // --- Configuration ---
    const CHECKOUT_BTN_SELECTOR = '.cart__checkout-button'; 
    
    // --- Element Variables ---
    const checkoutButton = document.querySelector(CHECKOUT_BTN_SELECTOR);
    const popup = document.getElementById('conversion-popup');
    const productList = document.getElementById('one-time-product-list');
    const noThanksButton = document.getElementById('no-thanks-button'); // Renamed to keep its function

    if (!checkoutButton || !popup) {
        console.warn('Conversion logic not fully initialized: Checkout button or popup missing.');
        return; 
    }

    // --- Core Functions ---

    const proceedToCheckout = () => {
        popup.style.display = 'none';
        //window.location.href = '/checkout';
    };

    /**
     * Collects all one-time line items from the cart drawer, reading dynamic data.
     * (Same as previous step - reads data-item-key, data-variant-id, etc.)
     */
    const collectOneTimeItems = () => {
        const items = document.querySelectorAll('[data-item-type="one-time"]');
        
        return Array.from(items).map(el => {
            const itemKey = el.getAttribute('data-item-key');
            const variantId = el.getAttribute('data-variant-id');
            const sellingPlanId = el.getAttribute('data-subscription-plan-id'); 
            const productImg = el.querySelector('.cart-item__image').getAttribute('src'); 
            const price = el.querySelector('.cart-item__price-wrapper .regular-price').innerText;
            const quantityElement = el.querySelector('.cart-item__quantity-input') || el.querySelector('.cart-item__quantity');
            const quantity = quantityElement ? quantityElement.querySelector('.quantity__input').value : 1;
            if (!sellingPlanId || sellingPlanId.trim() === '') {
                return null; 
            }
            
            return {
                key: itemKey,
                product_image: productImg,
                variantId: variantId,
                name: el.querySelector('.cart-item__name')?.textContent || 'One-Time Product',
                quantity: quantity,
                // regular_price: regular_price,
                compare_price:price,
                sellingPlanId: sellingPlanId
            };
        }).filter(item => item !== null);
    };

    /**
     * Builds the list with a separate "Convert" button for each item.
     */
    const buildProductList = (items) => {
        productList.innerHTML = '';
        items.forEach(item => {
            var regular_price = "";
            var compare_price = item.compare_price;
            if(item.quantity == 4) {
                var regular_price = "39";
            } else if(item.quantity == 2) {
                var regular_price = "25";
            } else if(item.quantity == 1) {
                var regular_price = "30";
            }
            if(regular_price == "" || regular_price == undefined){
                var compare_price = "";
            }
            let formattedAmount = 0;
            if (window?.Shopify?.currency?.rate) {
            const rate = Shopify.currency.rate;
            const currency = Shopify.currency.active;

            const discountInLocal = regular_price * rate;

            formattedAmount = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: currency
            }).format(discountInLocal);
            }
            
            const li = document.createElement('li');
            li.className = 'conversion-item';
            li.setAttribute('data-item-key', item.key); // Add item key to LI for easy reference
            li.innerHTML = `
            <div class="subscription-product-info">
                <div class="subscription-product-image">
                    <img src="${item.product_image}">
                </div>
                <div class="subscription-product-detail">
                    <span class="product-name">${item.name}</span> 
                    <dl>
                    <span class="popup-price popup-regular-price">${formattedAmount}</span>
                    <span class="popup-price popup-compare-price">${compare_price}</span>
                    </dl>
                    <button 
                        class="convert-single-item-btn button button--small button--primary" 
                        data-item-key="${item.key}"
                        data-item-variant="${item.variantId}"
                    >
                        Claim Offer
                    </button>
                </div>
            </div>
            `;
            productList.appendChild(li);
        });
        
        // Attach event listener to the newly created buttons
        productList.querySelectorAll('.convert-single-item-btn').forEach(button => {
            button.addEventListener('click', handleSingleConversion);
        });
    };

    /**
     * Handles the conversion process for a single item via Cart API.
     */
    async function handleSingleConversion(event) {
        const button = event.currentTarget;
        const itemKey = button.getAttribute('data-item-key');
        const itemVariant = button.getAttribute('data-item-variant');
        
        // Find the item details from the list of one-time items
        const itemToConvert = collectOneTimeItems().find(item => item.key === itemKey);
        
        // if (!itemToConvert) {
        //     alert('Error: Could not find item details for conversion.');
        //     return;
        // }

        button.disabled = true;
        button.textContent = 'Converting...';

        const changePayload = {
            id: parseInt(itemVariant), // Use 'line' parameter for cart/change.js
            quantity: 0              // Setting quantity to 0 removes the item
        };

        // Use the jQuery method if fetch continues to fail
        await new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: changePayload, // Uses 'application/x-www-form-urlencoded' format which is sometimes accepted
                dataType: 'json',
                success: resolve,
                error: (xhr) => reject(new Error(xhr.responseText || "400 Bad Request"))
            });
        });
        
        // 2. Prepare data for the second API call (Add subscription item)
        const additionsPayload = {
            items: [{
                id: itemVariant,
                quantity: itemToConvert.quantity,
                selling_plan: itemToConvert.sellingPlanId
            }]
        };
        await new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: additionsPayload, // Uses 'application/x-www-form-urlencoded' format which is sometimes accepted
                dataType: 'json',
                success: resolve,
                error: (xhr) => reject(new Error(xhr.responseText || "400 Bad Request"))
            });
        });
        // if(itemToConvert.quantity == 4) {
        //     var checkout_url = '/checkout?discount=30%25%20OFF%21';
        // } else if(itemToConvert.quantity == 2) {
        //     var checkout_url = '/checkout?discount=30%25%20OFF%21';
        // } else if(itemToConvert.quantity == 1) {
        //     var checkout_url = '/checkout?discount=30%25%20OFF%21';
        // } else {
        //     var checkout_url = '/checkout';
        // }
        button.textContent = 'Converted';
            if(document.querySelectorAll('.conversion-item').length > 1) {
                document.getElementById('no-thanks-button').setAttribute('href','/checkout');
                document.getElementById('re-direct-checkout').style.display = 'block';
            } else {
                window.location.href= '/checkout';
                document.getElementById('re-direct-checkout').style.display = 'none';
            }

        // async function updateCartIndicators() {
        //     try {
        //         const response = await fetch('/cart.js');
        //         const cart = await response.json();
        //         const totalItems = cart.item_count;
                
        //         // 1. Update the cart count number wherever it is displayed
        //         document.querySelector('.cart-count-bubble span[aria-hidden="true"]').textContent = totalItems;
        //         const cartIcon = document.querySelector('.header__icon--cart'); 
        //         if (cartIcon) {
        //             // Dispatch a click event to force the drawer to reopen/refresh
        //             cartIcon.dispatchEvent(new Event('click'));
        //             popup.style.display = 'none';
        //         }
        //         fetch(`${routes.cart_url}?section_id=cart-drawer`)
        //             .then((response) => response.text())
        //             .then((responseText) => {
        //             const html = new DOMParser().parseFromString(
        //                 responseText,
        //                 "text/html"
        //             );
        //             const selectors = [".cart-progress","cart-drawer-items", ".cart-drawer__footer"];
        //             for (const selector of selectors) {
        //                 const targetElement = document.querySelector(selector);
        //                 const sourceElement = html.querySelector(selector);
        //                 if (targetElement && sourceElement) {
        //                 targetElement.replaceWith(sourceElement);
        //                 }
        //             }
        //             $('cart-remove-button').addClass('custom--removed-product');
        //         });
                
        //     } catch (error) {
        //         console.error("Failed to fetch cart data:", error);
        //     }
        // }
        //  updateCartIndicators();
    }

    function handleCheckoutLogic() {
        // 2. Get all line items and determine the overall cart state
        const cartItems = document.querySelectorAll('.cart-drawer-item');
        let hasSubscription = false;
        let hasOneTime = false;

        cartItems.forEach(item => {
            const productType = item.getAttribute('data-item-type');
            if (productType === 'subscription') {
                hasSubscription = true;
            } else if (productType === 'one-time') {
                hasOneTime = true;
            }
        });

        // 3. Apply the custom rules
        if (hasOneTime && !hasSubscription) {
            // this (triggerSubscriptionPopup) function use for subscription popup 
            // triggerSubscriptionPopup();
            triggerUpsellPopup();
        } else if (hasSubscription) {
            // alert('--- upsell ---');
            triggerUpsellPopup();
        } else {
            // alert('--- checkout ---');
            proceedToCheckout();
        }
    }
    
    // --- Popup Functions (You need to define these and your HTML modal) ---
    function triggerSubscriptionPopup() {
        // alert('--- SHOW subscription POPUP ---');
        const oneTimeItems = collectOneTimeItems();
        if (oneTimeItems.length > 0) {
            buildProductList(oneTimeItems); // Build the list with individual buttons
            popup.style.display = 'flex'; // Show the modal
            const cartDrawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
            if (cartDrawer && typeof cartDrawer.close === 'function') {
                cartDrawer.close(); 
            }
        } else {
            proceedToCheckout();
        }
    }

    function triggerUpsellPopup() {
        const upsell_popup = document.getElementById('upsell-popup');
        upsell_popup.style.display = 'flex';
    }

    // --- MAIN EVENT LISTENER: Checkout Click ---
    document.body.addEventListener('click', (event) => {
        const checkoutButton = event.target.closest(CHECKOUT_BTN_SELECTOR);
        
        if (checkoutButton) {
            event.preventDefault();        
            handleCheckoutLogic();
        }
    });

    
   document.querySelector('.upsell-atc-want-btn').addEventListener('click', async (event) => {
        const button2 = event.currentTarget;
        const itemVariant2 = button2.getAttribute('data-product-id');

        const additionsPayload2 = {
            items: [{
                id: itemVariant2,
                quantity: 1,
            }]
        };

        try {
            await new Promise((resolve, reject) => {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    data: additionsPayload2,
                    dataType: 'json',
                    success: resolve,
                    error: (xhr) => reject(new Error(xhr.responseText || "400 Bad Request"))
                })
                .done(function() {
                    window.location.href = '/checkout';
                });
            });

        } catch (error) {
            console.error("Error adding item:", error);
        }
    });
    document.querySelector('.upsell-close-icon svg').addEventListener('click', async (event) => {
        window.location.href = '/checkout';
    });
    // document.addEventListener('click', function (e) {
    //     const btn = e.target.closest('.custom--removed-product');
    //     if (!btn) return;
    //     const line = btn.dataset.index;
    //     fetch('/cart/change.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ line: line, quantity: 0 })
    //     })
    //     .then(() => fetch('/cart.js'))
    //     .then(res => res.json())
    //     .then(cart => {
    //         setTimeout(() => {
    //             const selectedItems = document.querySelectorAll('cart-drawer-upsell[data-selected="true"]');
    //             if(cart.item_count == selectedItems.length) {
    //                 // document.querySelectorAll('.upsell--toggle_switch[data-selected="true"]').forEach(upsell_pro => {
    //                 //     upsell_pro.querySelector('.upsell__toggle-switch').click();
    //                 // });
    //                 const dataIds = Array.from(selectedItems, el => el.getAttribute('data-id'));
    //                 const updates = {};
    //                 dataIds.forEach(key => updates[key] = 0);

    //                 $.ajax({
    //                 type: 'POST',
    //                 url: '/cart/update.js',
    //                 dataType: 'json',
    //                 data: {
    //                     updates
    //                 },
    //                 success: function(cart) {
    //                     setTimeout(() => {
    //                         fetch(`${routes.cart_url}?section_id=cart-drawer`)
    //                             .then((response) => response.text())
    //                             .then((responseText) => {
    //                             const html = new DOMParser().parseFromString(
    //                                 responseText,
    //                                 "text/html"
    //                             );
    //                             const selectors = [".drawer__inner"];
    //                             for (const selector of selectors) {
    //                                 const targetElement = document.querySelector(selector);
    //                                 const sourceElement = html.querySelector(selector);
    //                                 if (targetElement && sourceElement) {
    //                                 targetElement.replaceWith(sourceElement);
    //                                 }
    //                             }
    //                             document.querySelector('cart-drawer').classList.add('is-empty');
    //                         });
    //                     }, 500);                    
    //                 },
    //                 error: function(err) {
    //                     console.error(err);
    //                 }
    //                 });
    //             }
    //         }, 100);
    //     });
    // });
});